import { collection, getDocs, query, where } from "firebase/firestore";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { ADD } from '../../redux/Actions/action';
import Loader from "../../components/Loader/Loader";
import { fireDB } from "../../firebase/FirebaseConfig";


const AllProduct = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const cartItems = useSelector((state) => state.cartreducer.carts);

    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [deliveredProducts, setDeliveredProducts] = useState({});
    const [sortOption, setSortOption] = useState("");

 // Pagination state
const [currentPage, setCurrentPage] = useState(1);
const productsPerPage = 8;

// Custom page setter (avoid name clash)
const handlePageChange = (page) => {
  localStorage.setItem("currentPage", page.toString());
  setCurrentPage(page);
  window.scrollTo({ top: 0, behavior: "smooth" }); // 👈 scroll to top smoothly
};

// On component mount, load saved page
useEffect(() => {
  const savedPage = parseInt(localStorage.getItem("currentPage") || "1", 10);
  setCurrentPage(savedPage);
}, []);


    const addCart = (item) => {
        dispatch(ADD(item));
        toast.success("Added to cart");
    };

    const handleProductClick = (product) => {
        let lastVisitedProducts = JSON.parse(localStorage.getItem("lastVisitedProducts")) || [];
        lastVisitedProducts = lastVisitedProducts.filter(p => p.id !== product.id);
        lastVisitedProducts.unshift(product);
        lastVisitedProducts = lastVisitedProducts.slice(0, 8);
        localStorage.setItem("lastVisitedProducts", JSON.stringify(lastVisitedProducts));
        navigate(`/productinfo/${product.id}`);
    };

    const getAllProducts = async () => {
        setLoading(true);
        try {
            const q = query(
                collection(fireDB, "products"),
                where("approved", "==", true)
            );
            const querySnapshot = await getDocs(q);
            const productsArray = [];
            querySnapshot.forEach((doc) => {
                productsArray.push({ id: doc.id, ...doc.data() });
            });
            setProducts(productsArray);
        } catch (error) {
            console.log(error);
            toast.error("Failed to load products");
        }
        setLoading(false);
    };

    const getDeliveredOrders = async () => {
        try {
            const q = query(collection(fireDB, "order"), where("status", "==", "delivered"));
            const querySnapshot = await getDocs(q);
            const deliveredItems = {};

            querySnapshot.forEach((doc) => {
                const orderData = doc.data();
                orderData.cartItems.forEach((item) => {
                    deliveredItems[item.id] = true;
                });
            });

            setDeliveredProducts(deliveredItems);
        } catch (error) {
            console.log(error);
            toast.error("Failed to load orders");
        }
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        getAllProducts();
        getDeliveredOrders();
    }, []);

    useEffect(() => {
        localStorage.setItem("cart", JSON.stringify(cartItems));
    }, [cartItems]);

    // Sort products
    let sortedProducts = [...products];
    if (sortOption === "lowToHigh") {
        sortedProducts.sort((a, b) => a.price - b.price);
    } else if (sortOption === "highToLow") {
        sortedProducts.sort((a, b) => b.price - a.price);
    }

    // Pagination logic
    const indexOfLastProduct = currentPage * productsPerPage;
    const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
    const currentProducts = sortedProducts.slice(indexOfFirstProduct, indexOfLastProduct);
    const totalPages = Math.ceil(sortedProducts.length / productsPerPage);

    return (
        <div className="">
            <div className="flex justify-center items-center">
                {loading && <Loader />}
            </div>

            {/* Sorting */}
            <div className="flex justify-start pt-4 ml-16 mb-5">
                <label className="mt-2 mr-2 md:text-lg text-sm">Sort by:</label>
                <select
                    className="border px-3 py-1 rounded-lg cursor-pointer"
                    value={sortOption}
                    onChange={(e) => setSortOption(e.target.value)}
                >
                    <option value="">Choose price filter</option>
                    <option value="lowToHigh">Price: Low to High</option>
                    <option value="highToLow">Price: High to Low</option>
                </select>
            </div>

            {/* Product List */}
            <section className="text-gray-600 body-font">
                <div className="px-8 py-5">
                    <div className="flex flex-wrap mx-auto">
                        {currentProducts.map((item, index) => {
                            const { id, title, price, productImageUrl, reviews, discount } = item;
                            const images = Array.isArray(productImageUrl) ? productImageUrl : productImageUrl ? [productImageUrl] : [];
                            const isSold = deliveredProducts[id];

                            return (
                                <div key={index} className=" p-3  ">
                                    <div className="relative bg-white   rounded-xl shadow-md border border-green-400 overflow-hidden">
                                        {discount && (
                                            <div className="absolute top-2 left-2 bg-yellow-400 text-xs font-semibold px-2 py-1 rounded">
                                                {discount}% OFF
                                            </div>
                                        )}
                                        <div className="flex justify-center  bg-white ">
                                            {images?.[0] && (
                                                <img
                                                    src={images[0]}
                                                    alt="Product"
                                                     loading="lazy"
                                                    onClick={() => handleProductClick(item)}
                                                    className="card h-[220px] w-[290px] border border-green-400  cursor-pointer"
                                                />
                                            )}
                                        </div>
                                        <div className="p-4 text-center">
                                            <h2 className="text-xs font-poppins text-gray-500 mb-1 uppercase tracking-wider">Durapot</h2>
                                            <h1 className="text-lg font-outfit font-medium text-gray-900 mb-2">
                                                {title.substring(0, 25)}
                                            </h1>
                                            <div className="flex justify-center items-center space-x-2 mb-2">
                                                <span className="text-gray-500 line-through  font-outfit text-lg font-medium">
                                                    ₹{Math.round(price * 1.10)}
                                                </span>
                                                <span className="text-green-700 italic  font-outfit text-lg font-medium">₹{price}</span>
                                            </div>
                                            {reviews && (
                                                <div className="flex justify-center items-center text-sm text-green-700 mb-3">
                                                    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-4 h-4 mr-1" viewBox="0 0 20 20">
                                                        <path d="M10 15l-5.878 3.09 1.122-6.545L.488 6.91l6.561-.954L10 0l2.951 5.956 6.561.954-4.756 4.635 1.122 6.545z" />
                                                    </svg>
                                                    <span>{reviews.rating} ({reviews.count} Reviews)</span>
                                                </div>
                                            )}
                                            <button
                                                onClick={() => handleProductClick(item)}
                                                className={`w-full py-2 rounded-lg bg-green-600 hover:bg-green-700 font-semibold font-outfit ${isSold ? "cursor-not-allowed" : "text-white"}`}
                                                disabled={isSold}
                                            >
                                                {isSold ? "Sold" : "View Product"}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </section>

{/* Pagination Controls */}
<div className="flex justify-center items-center gap-2 my-6">
    {/* Prev Button */}
    <button
        onClick={() => handlePageChange(Math.max(currentPage - 1, 1))}
        disabled={currentPage === 1}
        className="px-3 text-black font-semibold text-lg py-2 rounded-lg border hover:bg-gray-100 disabled:opacity-50"
    >
        {"<"}
    </button>

    {/* Page Numbers (show only 4 numbers at a time) */}
    {Array.from({ length: totalPages }, (_, i) => i + 1)
        .slice(
            Math.max(0, currentPage - 2),
            Math.min(totalPages, currentPage + 2)
        )
        .map((page) => (
            <button
                key={page}
                onClick={() => handlePageChange(page)}
                className={`px-4 py-2 rounded-lg text-sm font-medium ${
                    currentPage === page
                        ? "bg-blue-600 text-white"
                        : "bg-white border border-gray-300 hover:bg-gray-100"
                }`}
            >
                {page}
            </button>
        ))}

    {/* Next Button */}
    <button
        onClick={() => handlePageChange(Math.min(currentPage + 1, totalPages))}
        disabled={currentPage === totalPages}
        className="px-3 text-black font-semibold text-lg py-2 rounded-lg border hover:bg-gray-100 disabled:opacity-50"
    >
        {">"}
    </button>
</div>


        </div>
    );
};

export default AllProduct;
